import { MDSSidebarWidths } from "@/mds/foundations";

export enum SidebarVariant {
  Expanded = "expanded",
  Collapsed = "collapsed",
  Hidden = "hidden",
}

export const SIDEBAR_VARIANTS = {
  [SidebarVariant.Expanded]: { width: MDSSidebarWidths.expanded, x: 0, opacity: 1 },
  [SidebarVariant.Collapsed]: { width: MDSSidebarWidths.collapsed, x: 0, opacity: 1 },
  [SidebarVariant.Hidden]: { width: 0, x: -MDSSidebarWidths.expanded, opacity: 0 },
};
